import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/task/guide_table.png';
const _withScopeId = n => (_pushScopeId("data-v-1722df56"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "initiator-guide"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bg-top"
}, null, -1));
const _hoisted_3 = {
  class: "content"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "title-img",
  src: "https://p6.moimg.net/md/guide/guide_img_02.png",
  alt: "发起人指引标题"
}, null, -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "table-img",
  src: _imports_0,
  alt: "发起人指引表格"
}, null, -1));
import { useRouter } from 'vue-router';
import env from "md-base-tools/env";
import { onMounted } from 'vue';
import domain from "@/service/domain";
export default {
  setup(__props) {
    const router = useRouter();
    onMounted(() => {
      if (env.isModianIos() || env.isModianAndroid()) {
        // eslint-disable-next-line no-undef
        graft.app({
          functionName: "webRightItem",
          functionParams: {
            title: '众筹运营指引',
            url: `${domain.wap}/guide/index`
          }
        });
      }
    });
    const scrollToAnchor = anchor => {
      if (anchor === 'anchor1') {
        router.push('/guide/basic');
      } else if (anchor === 'anchor2') {
        router.push('/guide/operation');
        // eslint-disable-next-line no-undef
        // graft.app({
        //     functionName: "openController",
        //     functionParams: `md://create_project`,
        //     webFun: () => {
        //         if (env.isWxApp()) {
        //             // eslint-disable-next-line no-undef
        //             wx.miniProgram.navigateTo({
        //                 url: '/pages/projectPages/project-initiate/project-initiate'
        //             })
        //         } else {
        //             window.location.href = 'https://account.modian.com/m/initiate';
        //         }
        //     }
        // })
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_hoisted_4, _hoisted_5, _createElementVNode("div", {
        class: "anchor",
        onClick: _cache[0] || (_cache[0] = $event => scrollToAnchor('anchor1'))
      }), _createElementVNode("div", {
        class: "anchor anchor1",
        onClick: _cache[1] || (_cache[1] = $event => scrollToAnchor('anchor2'))
      })])]);
    };
  }
};